// extracted by mini-css-extract-plugin
module.exports = {"fields":"AddProductSheet_fields__1m3Jg","notice":"AddProductSheet_notice__1WKpB"};